import { t } from 'i18next';

export const locationTabs = {
  summary: {
    key: 'summary',
    label: t('locations.locationOverview'),
  },
  hours: {
    key: 'hours',
    label: t('locations.openingHours'),
  },
  assets: {
    key: 'assets',
    label: t('assets.assets'),
  },
  routes: {
    key: 'routes',
    label: t('routes.routes'),
  },
  users: {
    key: 'users',
    label: t('users.users'),
  },
  serviceMatrix: {
    key: 'services',
    label: t('locations.services'),
  },
  integrations: {
    key: 'integrations',
    label: t('locations.integrations.tabTitle'),
  },
};
